import { render, staticRenderFns } from "./jiuyeinfo.vue?vue&type=template&id=487aa5bf&scoped=true"
import script from "./jiuyeinfo.vue?vue&type=script&lang=js"
export * from "./jiuyeinfo.vue?vue&type=script&lang=js"
import style0 from "./jiuyeinfo.vue?vue&type=style&index=0&id=487aa5bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487aa5bf",
  null
  
)

export default component.exports